import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import { AppActions } from './ActionTypes';
import { authReducer } from '../reducers/auth.reducer';
import { toastReducer } from '../reducers/toast';
import { customersReducer } from '../reducers/customers.reducer';
import { couriersReducer } from '../reducers/couriers.reducer';
import { deliveryOrdersReducer } from '../reducers/deliveryOrders.reducer';
import { shippersReducer } from '../reducers/shippers.reducer';
import { transshipmentsReducer } from '../reducers/transshipments.reducer';
import { tripsReducer } from '../reducers/trips.reducer';
import { warehousesReducer } from '../reducers/warehouses.reducer';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export const rootReducer = combineReducers({
  auth: authReducer,
  toast: toastReducer,
  couriers: couriersReducer,
  customers: customersReducer,
  deliveryOrders: deliveryOrdersReducer,
  shippers: shippersReducer,
  transshipments: transshipmentsReducer,
  trips: tripsReducer,
  warehouses: warehousesReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export type AppState = ReturnType<typeof rootReducer>;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk as ThunkMiddleware<AppState, AppActions>)),
);
